import { isDuctedCompatibilitySystem } from 'utils/ducted-quote-layout';
import { NamedDuctedSystem } from 'utils/duplicate-system-name-types';

function normalizedName(name: string | null | undefined): string {
  return name?.trim() ?? '';
}

function isNumberedDuctedSystem(system: NamedDuctedSystem): boolean {
  return isDuctedCompatibilitySystem({ tags: [...(system.tags ?? [])] });
}

export function ductedDuplicateNameIndexes(
  systems: readonly NamedDuctedSystem[]
): ReadonlyMap<string, number> {
  const idsByName = new Map<string, string[]>();
  systems.forEach((system) => {
    const name = normalizedName(system.name);
    if (isNumberedDuctedSystem(system) && name !== '') {
      const ids = idsByName.get(name) ?? [];
      ids.push(system.id);
      idsByName.set(name, ids);
    }
  });

  const indexes = new Map<string, number>();
  idsByName.forEach((ids) => {
    if (ids.length > 1) {
      ids.forEach((id, index) => {
        indexes.set(id, index + 1);
      });
    }
  });
  return indexes;
}

export function nameWithDuplicateIndex(
  name: string,
  index: number | undefined
): string {
  if (index == null) return name;
  return `${name} ${index}`;
}

export function numberedDuctedSystemLabel(
  label: string,
  system: NamedDuctedSystem | undefined,
  indexes: ReadonlyMap<string, number>
): string {
  if (!system || normalizedName(system.name) !== normalizedName(label)) {
    return label;
  }
  return nameWithDuplicateIndex(label, indexes.get(system.id));
}
